export class EmailRecipient {
  name: string;
  email: string;
  phone: string;
  description: string;
  cities: string[];
  venues: string[];
  id: string;

  edited_by: string;
  created_by: string;
  full_access: boolean;

  constructor(data, id) {
    this.full_access = data["full_access"];
    this.name = data["name"];
    this.email = data["email"];
    this.phone = data["phone"];
    this.description = data["description"];
    this.cities = data["cities"];
    this.venues = data["venues"];
    this.edited_by = data["edited_by"];
    this.created_by = data["created_by"];
    this.id = id;
  }
  toJSON() {
    return {
      name: this.name,
      email: this.email,
      phone: this.phone,
      description: this.description,
      cities: this.cities,
      venues: this.venues,
      edited_by: this.edited_by,
      created_by: this.created_by,
      full_access: this.full_access
    };
  }
}
